var opposite = function opposite(term) {
  var pairs = [['left', 'right']];
  return pairs.find(function (pair) {
    return pair.includes(term);
  }).find(function (item) {
    return item !== term;
  });
};

export default opposite;